module.exports = "<svg width=\"867\" height=\"1017\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M-10 150.374C227.471 50.124 396.255 0 496.35 0c86.83 0 199.616 63.964 338.362 191.892 37.824 34.875 43.014 92.758 11.997 133.806L461.101 836.01a100 100 0 0 1-46.479 34.003L-10 1020V150.374z\" fill=\"#F2F3FA\" fill-rule=\"evenodd\" opacity=\".6\"/></svg>\n"


//////////////////
// WEBPACK FOOTER
// /www/client/src/components/Icon/blob.svg
// module id = 787
// module chunks = 0